import * as model from "@/model/prd/productionExecution/smelting/DrillDepth";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.DrillDepth(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d}`;
}

function time2str(time) {
  let date = new Date;
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  let h = time.getHours();
  let m = time.getMinutes();
  let s = time.getSeconds();
  return `${year}-${month+1}-${d} ${h}:${m}:${s}`;
}

const baseUrl = process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd";

const drillDepthStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentDrillDepth: {},
  },
  mutations: {
    setCurrentDrillDepth(state, data) {
      state.currentDrillDepth = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("drillDepth/setCurrentDrillDepth", item, {
        root: true
      });
      router.push({
        name: "drillDepthEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/drillDepth/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/drillDepth/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/drillDepth/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/drillDepth/getLength',
      }, { root: true })
    },
    saveCurrentDrillDepth(context) {
      return context.dispatch('saveDrillDepth', context.state.currentDrillDepth);
    },
    saveDrillDepth(context, drillDepth) {
      let data = new FormData();
      let id = drillDepth.id > 0 ? drillDepth.id : -1;
      data.append('id', id);
      data.append('date', date2str(drillDepth.date));
      data.append('furnaceNumber', drillDepth.furnaceNumber);
      data.append('furnaceTime', drillDepth.furnaceTime);
      data.append('drillNumber', drillDepth.drillNumber);
      data.append('startDate', date2str(drillDepth.startDate));
      data.append('endDate', drillDepth.endDate);
      data.append('startTime', time2str(drillDepth.startTime));
      data.append('endTime', drillDepth.endTime);
      data.append('depth', drillDepth.depth);
      data.append('mudName', drillDepth.mudName);
      data.append('mudNumber', drillDepth.mudNumber);
      data.append('drillTubeNumber', drillDepth.drillTubeNumber);
      data.append('otherTubeNumber', drillDepth.otherTubeNumber);
      data.append('slagState', drillDepth.slagState);
      data.append('remark', drillDepth.remark);
      return context.dispatch('api/post', {
        url: baseUrl + '/drillDepth',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(drillDepthStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)